<template>
  <transition name="slide">   
      <b-card no-body>
        <b-card-header>
              Inventory List 
        </b-card-header>
        <b-card-body>
        <b-row>
          <b-col md="1">
              <b-form-select :options="pageOptions" v-model="perPage" />
          </b-col>
          <b-col md="2" offset-md="2" v-if="hideorg">
              <b-form-select v-model="orgSelected" :options="orgItems"  />  
          </b-col>
          <b-col md="3" v-if="hideorg">
            <b-button-group>  
              <b-button size="sm" v-b-tooltip.hover variant="primary" title="Apply Filter" @click.stop="applyfilter()"><i class="fa fa-filter"></i> Filter</b-button>
              <b-button size="sm" v-b-tooltip.hover variant="warning" title="Clear Filter" @click.stop="clearfilter()"><i class="fa fa-times-circle"></i> Clear</b-button>
            </b-button-group>   
          </b-col>
          <b-col md="4" :offset-md="offsetsearch">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''" title="Clear Search"><i class="fa fa-times-circle"></i></b-btn>
                  </b-input-group-append>
                </b-input-group>
          </b-col>  
        </b-row>
        <br/>   
        <b-table responsive show-empty id="roletable" :busy.sync="isBusy" :filter="filter" :items="myProvider" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <template v-slot:cell(vehindex)="data">
            <strong>{{data.item.vehindex}}</strong>
          </template>
          <template v-slot:cell(vehreceiptdate)="data">
            {{data.item.vehreceiptdate | dateFormat }}
          </template>
          <template v-slot:cell(vehmfrdate)="data">
            <span v-if="data.item.vehmfrdate != ''">
              {{data.item.vehmfrdate | dateFormat }}
            </span>              
          </template>
          
          <template v-slot:cell(action)="data">
            <b-dropdown text="Action" size="sm" right>
              <b-dropdown-item-button v-b-tooltip.hover title="View" @click.stop="info(data.item)"><i class="fa fa-eye" ></i> View</b-dropdown-item-button>
              <b-dropdown-item-button v-b-tooltip.hover title="Edit" @click.stop="edit(data.item)"><i class="fa fa-edit"></i>Edit </b-dropdown-item-button>
              <b-dropdown-item-button v-b-tooltip.hover title="Delete" @click.stop="del(data.item)"><i class="fa fa-remove"></i> Delete</b-dropdown-item-button>
            </b-dropdown>   
          </template>
          <template v-slot:emptyfiltered="scope">
            <div role="alert" aria-live="polite">
              <div class="text-center my-2">There are no records matching your request.You can add Inventory by clicking on button below. </div>
              <div class="text-center my-2">
                <b-button title="Add Inventory" v-b-tooltip.hover size="sm" variant="primary" @click.stop="addInventry()"><span> Add Inventory</span></b-button>
              </div>
            </div>
          </template>
        </b-table>
        <nav v-if="totalRows>0">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
        <b-modal ref="myModalRef" size="lg" :title="modalTitle" ok-only ok-title="Cancel">
          <div class="d-block">
            <table width="100%">
                <tr>
                  <td>Vin Number: <strong v-html="modalform.vehvin"></strong></td>
                  <td>Receipt Date : <strong>{{ modalform.vehreceiptdate | dateFormat }}</strong></td>
                </tr>
                <tr>
                  <td>Mfr : <strong v-html="modalform.vehmfr"></strong></td>
                  <td>Mfr Date: <strong>{{ modalform.vehmfrdate | dateFormat }}</strong></td>
                </tr>
                <tr>
                  <td>Make : <strong v-html="modalform.vehyear"></strong></td>
                  <td>Model: <strong v-html="modalform.vehmodel"></strong></td>
                </tr>
            </table>  
          </div>
        </b-modal>
      </b-card> 
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex' 
import { getResponseMessages, getUserInfo } from '../../_helpers';
export default {
  name: 'Inventory_List',
  data: () => {
    return {
      offsetsearch:7,
      hideorg:false,
      orgSelected:'',
      orgItems :[{
        text: 'Filter By Org',
        value: '',
      }],
      itemsData: [],
      fields: [
        {key: 'vehindex',sortable:true,label: 'Index'},
        {key: 'vehreceiptdate',sortable:true,label: 'Receipt Date'},
        {key: 'vehvin',sortable:true, label: 'Vin No'},
        {key: 'vehmfrdate',sortable:true, label: 'Mfr Date'},
        {key: 'vehmfr',sortable:true, label: 'Mfr'},
        {key: 'vehyear',sortable:true, label: 'Make'},
        {key: 'vehmodel',sortable:true, label: 'Model'},
        {key: 'orgname',sortable:true, label: 'Org Name'},
        {key: 'action',label: 'Action'}
      ],
      isBusy: false,
      lastPerPage: 5,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [ 5, 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalform:{},
      modalTitle:''
    }
  },
  computed: {
    ...mapGetters(["getRecordTotal", "getRecords"])
  }, 
  created(){
    const user = getUserInfo();
    if(user.roleid == 1){
      this.hideorg = true
      this.offsetsearch = 0
    }
    this.loadUserData();
  },       
  methods: {
    ...mapActions('org', ['getById','getList','delById']),
    myProvider(ctx){
      this.isBusy = true
      if(this.lastPerPage != ctx.perPage){
        this.lastPerPage = ctx.perPage;
        ctx.currentPage = 1;
      }
      var startVal = (ctx.currentPage-1) * ctx.perPage
      ctx['start'] = startVal
      ctx['length'] = ctx.perPage
      ctx['orgid'] = this.orgSelected
      this.itemsData = [];
      let promise = this.$store.dispatch('getList',{ url:'vehicles/index',data: ctx })
      let itemsx = []
      return promise.then((res) => {
          itemsx = this.$store.state.org.records
          this.totalRows = this.$store.state.org.recordTotal
          return(itemsx)
      })
      return(itemsx)
    },
    info (item) {
      this.$router.push('/inventory/view/'+item.vehindex)
      /*this.$store.dispatch('getById', {url:'vehicles/getVehicleById',data : { 'vehIndex':item.vehindex  }}).then((res) => {
        this.modalform = Object.assign({}, res)
        this.modalTitle = 'Detail :- '+res.vehvin
        this.$refs.myModalRef.show()  
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });*/
    },
    edit (item) {
      this.$router.push('/inventory/edit/'+item.vehindex)
    },
    addInventry () {
      this.$router.push('/inventory/add')
    },
    clearfilter(){
      this.orgSelected = ''
      this.applyfilter()
    },
    applyfilter(){
      this.$root.$emit('bv::refresh::table', 'roletable');
    },
    loadUserData() {
      this.$store.dispatch('getById', {url:'user/loadUserData',data :{}}).then((res) => {
        res.org.forEach((version) => {
          this.orgItems.push(version);
        });
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    del(item) {
        this.$swal({
            title: 'Are you sure?',
            text: 'You want to remove this Inventory!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
                this.$store.dispatch('delById', {url:'vehicles/removeVehicle',data : { 'vehIndex':item.vehindex }}).then((res) => {
                  
                  this.$swal('Deleted!',getResponseMessages(res.data.messages),'success')
                  this.$root.$emit('bv::refresh::table', 'roletable');
                },(error) =>{
                  this.$swal('Cancelled',getResponseMessages(error.data.messages),'error')
                });
            }
          })
    } 
  }
}
</script>
